const initialState = {
  searchResult: {},
  searchCriteria: {},
  sortFields: [],
};

export default function domesticTrackingDashboardReducer(
  state = initialState,
  action,
) {
  switch (action.type) {
    case 'SET_DOMESTIC_TD_SEARCH_CRITERIA':
      return { ...state, ...action.payload };
    case 'SET_DOMESTIC_TD_SORT':
      return { ...state, sortFields: action.payload };
    case 'SET_DOMESTIC_TD_SEARCH_RESULT':
      return { ...state, ...action.payload, lastUpdateTs: new Date() };
    case 'RESET_DOMESTIC_TD_SEARCH':
      return initialState;
    default:
      return state;
  }
}
